module.exports = __webpack_public_path__ + "static/media/FOeYt4E.70601755.png";